module.exports = __webpack_public_path__ + "4366ce90c664f80066629a0ca18bcbab.png";